
import axios from '../config/axios';

export const url = '/api/contacto88q9vg'


export const createcontacto88q9vg = ({
  token,
	nombrecompletonpdt9,
	emailmdp4i,
	asuntoiyv8d,
	consulta6ff87l,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombrecompletonpdt9 && emailmdp4i && asuntoiyv8d && consulta6ff87l ) {

    axios.post(`${url}//create/basic/69024675e30724925006c86b`, {
		nombrecompletonpdt9,
		emailmdp4i,
		asuntoiyv8d,
		consulta6ff87l,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombrecompletonpdt9) {
		reject({
			status: 'error',
			info: 'nombrecompletonpdt9 no esta definido',
		});
	}  else if (!emailmdp4i) {
		reject({
			status: 'error',
			info: 'emailmdp4i no esta definido',
		});
	}  else if (!asuntoiyv8d) {
		reject({
			status: 'error',
			info: 'asuntoiyv8d no esta definido',
		});
	}  else if (!consulta6ff87l) {
		reject({
			status: 'error',
			info: 'consulta6ff87l no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

